import { types } from "./action";

const initialState = {
  byReleaseId: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_RELEASE_TRACKS: {
      const { releaseId, tracks } = action.payload || {};
      if (releaseId == null) {
        return state;
      }
      return {
        ...state,
        byReleaseId: {
          ...state.byReleaseId,
          [String(releaseId)]: Array.isArray(tracks) ? tracks : [],
        },
      };
    }
    case types.UPSERT_RELEASE_TRACK: {
      const { releaseId, track } = action.payload || {};
      if (releaseId == null || !track || track.id == null) {
        return state;
      }
      const key = String(releaseId);
      const prevTracks = state.byReleaseId[key] || [];
      const sid = String(track.id);
      const idx = prevTracks.findIndex(t => String(t.id) === sid);
      const nextTracks = [...prevTracks];
      if (idx >= 0) {
        nextTracks[idx] = { ...nextTracks[idx], ...track };
      } else {
        nextTracks.push(track);
      }
      return {
        ...state,
        byReleaseId: {
          ...state.byReleaseId,
          [key]: nextTracks,
        },
      };
    }
    default:
      return state;
  }
};
